/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@moms/Utility/StructuredTextParser';
import { isOpenInNewTab, refineUrlDomain } from '@moms/Utility/utils';

/* Styles */
import SimpleButton from '@moms/Buttons/SimpleButton';
import ToolKitBannerSt from '@moms/styleData/ToolkitBannerSt';
import { render } from 'datocms-structured-text-to-html-string';
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const ToolkitBanner = ({ region, lang, sectionContent }) => {
  const data = sectionContent[0];
  return (
    <Box
      pt={{ base: '1.5rem', md: '4rem' }}
      pb="30px"
      px="1rem"
      backgroundImage={{
        base: data?.mobileImage?.url || data?.desktopImage?.url,
        md: data?.desktopImage?.url,
      }}
      bgRepeat="no-repeat"
      bgPos="center"
      bgSize="cover"
    >
      <Box
        py={{ base: '4rem', md: '4rem' }}
        px=".5rem"
        maxW={1330}
        mx="auto"
        w="100%"
      >
        <Flex
          flexDir={'column'}
          gap={{ base: '3rem', md: '3.5rem' }}
          // borderBottom={'2px solid #FFFFFF33'}
        >
          <Box
            display={{ base: 'block', md: 'flex' }}
            textAlign={'center'}
            justifyContent={'center'}
            flexWrap="wrap"
            {...ToolKitBannerSt?.[lang]?.title}
            gap=".8rem"
            as="h1"
          >
            <Text color={'#EC2224'} fontStyle={lang === 'en' ? 'italic' : ''}>
              {data?.title}
            </Text>
            <Text as="span">
              <StructuredTextParser
                color={'#FFFFFF'}
                fontStyle={lang === 'en' ? 'normal' : ''}
                as="span"
                textAlign="center"
                display="inline"
                str={render(data?.titleSubtext?.value)}
                {...ToolKitBannerSt?.[lang]?.title}
              />
            </Text>
          </Box>

          <Text
            // {...ToolKitBannerSt?.[lang]?.desc}
            maxW={'686px'}
            mx={'auto'}
            // px={{ base: '2rem', md: '0' }}
          >
            <StructuredTextParser
              color={'#FFFFFF'}
              fontStyle={lang === 'en' ? 'normal' : ''}
              as="span"
              display="inline"
              str={render(sectionContent[0].description.value)}
              w={'686px'}
              mx={'auto'}
              px={{ base: '2rem', md: '0' }}
              {...ToolKitBannerSt?.[lang]?.desc}
            />
          </Text>
          {/* <Link
            maxW={238}
          > */}
          <SimpleButton
            href={refineUrlDomain(data?.button[0]?.linkUrl, region, lang)}
            target={isOpenInNewTab(data?.button[0]?.linkUrl) ? '_blank' : ''}
            _hover={{ bg: '#B21522', textDecor: 'none' }}
            _active={{ bg: '#B21522', textDecor: 'none' }}
            _focus={{ bg: '#B21522', textDecor: 'none' }}
            // display="block"
            mx={{ base: 'auto' }}
            bgColor={'#EC1C2D'}
            height="auto"
            // as={Link}
            border={'none'}
            px="30px"
            py="18px"
            maxW={238}
            width={{ base: '100%', sm: '238px' }}
            borderRadius={'124.5px'}
            style={{
              linkUrl: data?.button[0]?.linkUrl,
              buttonText: data?.button[0]?.buttonText,
              buttonStyle: data?.button[0]?.buttonStyle,
            }}
            wordBreak="break-all"
            textAlign="center"
            {...ToolKitBannerSt?.[lang]?.Btn}
          >
            {/* <Text wordBreak="break-all" width="100%">
              {data?.button[0]?.buttonText}
            </Text> */}
          </SimpleButton>
          {/* </Link> */}
        </Flex>
      </Box>
    </Box>
  );
};

export default ToolkitBanner;
